var _defs, _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "background-1_svg__background",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1930.42 2360.14"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-1_svg__Unbenannter_Verlauf_3",
    x1: 1,
    y1: 2350.7,
    x2: 2,
    y2: 2350.7,
    gradientTransform: "rotate(180 1906.89 2241292.69) scale(1906.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-1_svg__Unbenannter_Verlauf_3-2",
    x1: 1,
    y1: 2351.53,
    x2: 2,
    y2: 2351.53,
    gradientTransform: "rotate(180 1906.89 2242078.675) scale(1906.39)",
    xlinkHref: "#background-1_svg__Unbenannter_Verlauf_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-1_svg__Unbenannter_Verlauf_3-3",
    x1: 1,
    y1: 2351.12,
    x2: 2,
    y2: 2351.12,
    gradientTransform: "matrix(1876.48 0 0 -1876.48 -1824.64 4413063.5)",
    xlinkHref: "#background-1_svg__Unbenannter_Verlauf_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-1_svg__Unbenannter_Verlauf_2",
    x1: -5.87,
    y1: 387.88,
    x2: 1900.52,
    y2: 387.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-1_svg__Unbenannter_Verlauf_4",
    x1: -5.87,
    y1: 1959.85,
    x2: 1900.52,
    y2: 1959.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-1_svg__Unbenannter_Verlauf",
    x1: 44.97,
    y1: 1173.87,
    x2: 1921.45,
    y2: 1173.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "background-1_svg__clip-path",
    transform: "translate(5.87 7.29)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "background-1_svg__cls-4",
    d: "M-5.87-7.29h1930.42v2474.7H-5.87z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "background-1_svg__clip-path-3",
    transform: "translate(5.87 7.29)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "background-1_svg__cls-4",
    d: "M-14.87-12.11h1924.39v793.98H-14.87z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "background-1_svg__clip-path-4",
    transform: "translate(5.87 7.29)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "background-1_svg__cls-4",
    d: "M-14.87 1559.86h1924.39v793.98H-14.87z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "background-1_svg__clip-path-5",
    transform: "translate(5.87 7.29)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "background-1_svg__cls-4",
    d: "M35.97 773.87h1894.48v793.99H35.97z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "background-1_svg__luminosity-noclip",
    x: -14.87,
    y: -12.11,
    width: 1939.42,
    height: 2479.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "background-1_svg__luminosity-noclip-2",
    x: -14.87,
    y: -7.29,
    width: 1939.42,
    height: 2474.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "background-1_svg__luminosity-noclip-3",
    x: -5.87,
    y: -7.29,
    width: 1936.32,
    height: 2474.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "background-1_svg__mask",
    x: -9,
    y: -4.82,
    width: 1939.42,
    height: 2479.52,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#background-1_svg__luminosity-noclip)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-1_svg__Unbenannter_Verlauf_3)",
    d: "M-5.87-7.29h1930.42v2474.7H-5.87z",
    transform: "translate(5.87 7.29)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "background-1_svg__mask-2",
    x: -9,
    y: 0,
    width: 1939.42,
    height: 2474.7,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#background-1_svg__luminosity-noclip-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-1_svg__Unbenannter_Verlauf_3-2)",
    d: "M-5.87-7.29h1930.42v2474.7H-5.87z",
    transform: "translate(5.87 7.29)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "background-1_svg__mask-3",
    x: 0,
    y: 0,
    width: 1936.32,
    height: 2474.7,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#background-1_svg__luminosity-noclip-3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-1_svg__Unbenannter_Verlauf_3-3)",
    d: "M-5.87-7.29h1930.42v2474.7H-5.87z",
    transform: "translate(5.87 7.29)"
  }))), /*#__PURE__*/React.createElement("style", null, ".background-1_svg__cls-4{fill:none}.background-1_svg__cls-5{clip-path:url(#background-1_svg__clip-path)}.background-1_svg__cls-6{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "background-1_svg__cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "background-1_svg__cls-6",
    d: "M161.42 1056.09c-.36 2.12-1.43 4.46-4.23 4s-6.9-.63-6.74-5c.12-3 1.47-6.09 5.34-5.75 3.56.31 5.59 2.57 5.63 6.67M148.66 1511.53c-.3 1.73-1.17 3.64-3.46 3.3s-5.65-.51-5.51-4c.09-2.43 1.2-5 4.36-4.71 2.92.26 4.57 2.1 4.61 5.46M64.32 1236.7c-.29 1.73-1.16 3.64-3.45 3.3s-5.65-.51-5.52-4.06c.1-2.43 1.2-5 4.37-4.7 2.92.26 4.57 2.1 4.6 5.46M57.59 2136.93c-.29 1.73-1.16 3.64-3.45 3.3s-5.65-.51-5.51-4.05c.09-2.43 1.2-5 4.36-4.71 2.92.26 4.57 2.1 4.6 5.46M337.06 1148.55c-.29 1.74-1.17 3.65-3.45 3.3s-5.65-.51-5.52-4c.1-2.43 1.2-5 4.37-4.71 2.91.26 4.57 2.1 4.6 5.46M136.1 1037.83c-.3 1.73-1.17 3.64-3.46 3.3s-5.65-.51-5.51-4.06c.09-2.43 1.2-5 4.36-4.7 2.92.26 4.57 2.1 4.61 5.46M1286 1510.73c-1.83.81-1.65 1.13.38.72l15.66-3.16c2-.41 2.51.24 1 1.44l-11.24 9.27c-1.47 1.2-1.2 1.48.59.62l15.74-7.56c1.79-.86 2.66-.23 1.94 1.4l-3.38 7.65c-.72 1.63-.17 1.94 1.23.68l10.76-9.63a2.38 2.38 0 013.73.58l2.74 4.37c1 1.64 2.32 1.6 2.89-.08l2.46-7.2c.58-1.68 2.75-2.69 4.86-2.25l9.62 2c1.79.38 2.37-.37 1.3-1.66l-3.37-4.08c-1.27-1.53-.62-3 1.45-3.39l15.24-2.55c2.06-.35 2-.88-.13-1.2l-10-1.47c-2.13-.32-2.38-1.23-.55-2l16-7.14c1.82-.81 1.65-1.13-.39-.72l-15.66 3.16c-2 .41-2.5-.23-1-1.44l11.24-9.27c1.46-1.21 1.19-1.49-.59-.63l-15.74 7.56c-1.79.86-2.66.23-1.94-1.4l3.37-7.65c.72-1.63.17-1.94-1.23-.68l-10.76 9.64a2.38 2.38 0 01-3.72-.59l-2.75-4.37c-1-1.63-2.32-1.6-2.89.08l-2.46 7.21c-.57 1.68-2.75 2.68-4.86 2.24l-9.61-2c-1.79-.37-2.37.37-1.3 1.66l3.37 4.11c1.26 1.52.61 3-1.45 3.38l-15.24 2.55c-2.07.35-2 .88.12 1.2l10 1.48c2.13.31 2.38 1.22.56 2zM45.79 1060.57c-1.11-1.65-1.4-1.43-.64.51L51 1076c.76 1.94.21 2.51-1.24 1.28l-11.08-9.46c-1.44-1.23-1.67-.92-.52.69l10.18 14.19c1.16 1.61.69 2.58-1 2.15l-8.12-2c-1.73-.42-1.94.17-.45 1.34l11.35 8.92a2.37 2.37 0 01.07 3.77l-3.83 3.46c-1.43 1.29-1.16 2.56.59 2.83l7.52 1.18c1.75.27 3.12 2.24 3.05 4.39l-.31 9.82c0 1.83.78 2.27 1.87 1l3.43-4c1.29-1.51 2.89-1.13 3.59.84l5.16 14.57c.7 2 1.21 1.82 1.15-.33l-.27-10.08c-.06-2.15.79-2.55 1.91-.9l9.81 14.57c1.12 1.65 1.4 1.43.65-.51l-5.84-14.87c-.75-1.94-.2-2.51 1.24-1.28l11.09 9.46c1.44 1.23 1.67.92.51-.69l-10.18-14.19c-1.15-1.61-.69-2.57 1-2.15l8.11 2c1.73.42 1.94-.17.46-1.34l-11.36-8.92a2.39 2.39 0 01-.07-3.77l3.83-3.46c1.43-1.29 1.17-2.56-.59-2.83l-7.52-1.17c-1.75-.28-3.12-2.25-3.05-4.4l.31-9.82c.06-1.82-.78-2.27-1.86-1l-3.44 4c-1.28 1.51-2.89 1.13-3.58-.84l-5.16-14.57c-.7-2-1.22-1.82-1.16.33l.28 10.08c.06 2.15-.8 2.55-1.91.9z",
    transform: "translate(5.87 7.29)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M0 0h1930.42v2360.14H0z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "background-1_svg__cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#background-1_svg__clip-path-3)",
    mask: "url(#background-1_svg__mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1507.53-5.11c217 0 393 176 393 393s-176 393-393 393H387.13c-217 0-393-175.94-393-393s176-393 393-393z",
    transform: "translate(5.87 7.29)",
    fill: "url(#background-1_svg__Unbenannter_Verlauf_2)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#background-1_svg__clip-path-4)",
    mask: "url(#background-1_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1507.53 1566.86c217 0 393 175.94 393 393s-176 393-393 393H387.13c-217 0-393-175.94-393-393s176-393 393-393z",
    transform: "translate(5.87 7.29)",
    fill: "url(#background-1_svg__Unbenannter_Verlauf_4)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#background-1_svg__clip-path-5)",
    mask: "url(#background-1_svg__mask-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438 780.87c-217 0-393 176-393 393s176 393 393 393h1090.5c217 0 393-176 393-393s-175.94-393-393-393z",
    transform: "translate(5.87 7.29)",
    fill: "url(#background-1_svg__Unbenannter_Verlauf)"
  })))));
}
export default __webpack_public_path__ + "445decae89bf1d533d64e1bf167890c8.svg";
export { SvgBackground1 as ReactComponent };